// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/auth/auth.proto" (package "mlmbox.client.auth", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Auth } from "./auth.ts";
import type { RemoteSignInEvent } from "./auth.ts";
import type { ServerStreamingCall } from "@protobuf-ts/runtime-rpc";
import type { TokenGenerateResponse } from "./auth.ts";
import type { Account_Id } from "../../types/account.ts";
import type { TokenValidateResponse } from "./auth.ts";
import type { Empty } from "../../../google/protobuf/empty.ts";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { AuthSignResponse } from "./auth.ts";
import type { TelegramBotSignRequest } from "./auth.ts";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service mlmbox.client.auth.Auth
 */
export interface IAuthClient {
    /**
     * @generated from protobuf rpc: TelegramBotSign(mlmbox.client.auth.TelegramBotSignRequest) returns (mlmbox.client.auth.AuthSignResponse);
     */
    telegramBotSign(input: TelegramBotSignRequest, options?: RpcOptions): UnaryCall<TelegramBotSignRequest, AuthSignResponse>;
    /**
     * @generated from protobuf rpc: TokenValidate(google.protobuf.Empty) returns (mlmbox.client.auth.TokenValidateResponse);
     */
    tokenValidate(input: Empty, options?: RpcOptions): UnaryCall<Empty, TokenValidateResponse>;
    /**
     * @generated from protobuf rpc: TokenGenerate(mlmbox.types.Account.Id) returns (mlmbox.client.auth.TokenGenerateResponse);
     */
    tokenGenerate(input: Account_Id, options?: RpcOptions): UnaryCall<Account_Id, TokenGenerateResponse>;
    /**
     * @generated from protobuf rpc: RemoteSignIn(google.protobuf.Empty) returns (stream mlmbox.client.auth.RemoteSignInEvent);
     */
    remoteSignIn(input: Empty, options?: RpcOptions): ServerStreamingCall<Empty, RemoteSignInEvent>;
}
/**
 * @generated from protobuf service mlmbox.client.auth.Auth
 */
export class AuthClient implements IAuthClient, ServiceInfo {
    typeName = Auth.typeName;
    methods = Auth.methods;
    options = Auth.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: TelegramBotSign(mlmbox.client.auth.TelegramBotSignRequest) returns (mlmbox.client.auth.AuthSignResponse);
     */
    telegramBotSign(input: TelegramBotSignRequest, options?: RpcOptions): UnaryCall<TelegramBotSignRequest, AuthSignResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<TelegramBotSignRequest, AuthSignResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: TokenValidate(google.protobuf.Empty) returns (mlmbox.client.auth.TokenValidateResponse);
     */
    tokenValidate(input: Empty, options?: RpcOptions): UnaryCall<Empty, TokenValidateResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, TokenValidateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: TokenGenerate(mlmbox.types.Account.Id) returns (mlmbox.client.auth.TokenGenerateResponse);
     */
    tokenGenerate(input: Account_Id, options?: RpcOptions): UnaryCall<Account_Id, TokenGenerateResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<Account_Id, TokenGenerateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RemoteSignIn(google.protobuf.Empty) returns (stream mlmbox.client.auth.RemoteSignInEvent);
     */
    remoteSignIn(input: Empty, options?: RpcOptions): ServerStreamingCall<Empty, RemoteSignInEvent> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, RemoteSignInEvent>("serverStreaming", this._transport, method, opt, input);
    }
}
